import { Icons, ListItemProps } from '@silverfort/sf-components';
import { AD_ENTITY_TYPES, ENTITY_SELECTOR_FILTER_TYPES } from '@silverfort-nodelibs/common/utils/consts';

export const ENTITY_TYPES: ListItemProps<number>[] = [
    ENTITY_SELECTOR_FILTER_TYPES.USERS_ONLY,
    ENTITY_SELECTOR_FILTER_TYPES.GROUPS_ONLY,
    ENTITY_SELECTOR_FILTER_TYPES.OUS_ONLY
].map((type) => ({
    value: type.searchEntitiesTypes?.[0] ?? AD_ENTITY_TYPES.USER,
    title: type.buttonText
}));

export const FIELD_OPTIONS: ListItemProps<string>[] = [
    { value: 'name', title: 'Display name' },
    { value: 'path', title: 'Full path' },
    { value: 'sam', title: 'Sam account name' }
];

export const ENTITY_TYPE_TO_ICON = {
    [AD_ENTITY_TYPES.USER]: Icons.User,
    [AD_ENTITY_TYPES.GROUP]: Icons.UserGroup,
    [AD_ENTITY_TYPES.OU]: Icons.UserGroup,
    [AD_ENTITY_TYPES.HOST]: Icons.Server,
    [AD_ENTITY_TYPES.SERVER]: Icons.Server,
    [AD_ENTITY_TYPES.IP]: Icons.Server,
    [AD_ENTITY_TYPES.APPLICATION]: Icons.Server
};
